import { useLazyQuery } from '@apollo/client';
import getStoreDetailsQuery from '../queries/store-details/getStoreDetailsQuery';
import { useQuery } from './useQuery';

const useStoreDetails = ({
  storeId,
  ssr = false,
  lazy = false
}) => {

  const Query = getStoreDetailsQuery();

  const opts = {
    ssr,
    errorPolicy: 'all',
    variables: {
      storeId
    }
  };

  if (lazy) {
    return useLazyQuery(Query, opts);
  }
  return useQuery(Query, opts);

};

export default useStoreDetails;
